import { lazy } from 'react';

const BookingPage = lazy(() => import('./BookingPage'));

export default BookingPage;

